import API from "api/endpoints";
import axiosInstance from "api/axiosInstance";

export const departmentService = {
  fetchDeaprtments: async () => {
    try {
      const response = await axiosInstance.get(API.department.getList);
      return response.data;
    } catch (eror) {
      console.error("Eror in fetching departments", eror);
    }
  },

  createDepartment: async (paylaod) => {
    try {
      const res = axiosInstance.post(API.department.createDepartment, paylaod);
      return (await res).data;
    } catch (err) {
      throw err;
    }
  },

  updateDepartment: async (payload) => {
    try {
      const response = await axiosInstance.put(API.department.update, payload);
    } catch (error) {
      throw error;
    }
  },
  
};
